import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConfig, useCurrentUser, usePusher, } from '@marvelapp/ballpark-application';
import { BtwButton, BtwLink, BtwText, Stack, } from '@marvelapp/ballpark-components';
import { LiveIcon } from '@marvelapp/ballpark-icons';
import { PusherEvent } from '@marvelapp/core';
import { showNotification, toast } from '@marvelapp/ui-internal';
export function SubscribeLiveSessionStartedOrEnded() {
    const { pathname } = useLocation();
    const config = useConfig();
    const { pk: userId } = useCurrentUser();
    const { pusher } = usePusher();
    useEffect(() => {
        if (!userId ||
            pathname.startsWith('/record') ||
            pathname.includes(`/live/`))
            return;
        const channelName = `${config.pusher.userChannelPrefix}${userId}`;
        const { bindChannel } = pusher.subscribe(channelName);
        const handleLiveSessionStarted = (eventData) => {
            const { content: { display_name: displayName, room_name: roomId, usertest_uuid: userTestUuid, usertest_pk: userTestPk, usertest_name: userTestName, researcher_present: hasResearcherJoined, }, } = eventData;
            if (!hasResearcherJoined) {
                showLiveSessionNotification({
                    displayName,
                    userTestUuid,
                    roomId,
                    userTestName,
                    userTestPk,
                    pathname,
                });
            }
        };
        const handleLiveSessionEnded = (eventData) => {
            const { content: { room_name: roomId }, } = eventData;
            toast.dismiss(roomId);
        };
        const unbindSessionStarted = bindChannel(PusherEvent.LiveSessionStarted, handleLiveSessionStarted);
        const unbindSessionEnded = bindChannel(PusherEvent.LiveSessionEnded, handleLiveSessionEnded);
        return () => {
            unbindSessionStarted();
            unbindSessionEnded();
        };
    }, [
        config.pusher.projectChannelPrefix,
        config.pusher.userChannelPrefix,
        pathname,
        pusher,
        userId,
    ]);
    return null;
}
const showLiveSessionNotification = ({ displayName, userTestUuid, roomId, userTestName, userTestPk, pathname, }) => {
    const isUserInCurrentLiveProject = pathname.includes(`/${userTestPk}/`);
    return showNotification({
        toastId: roomId,
        component: (_jsxs(Stack, { direction: "row", gap: "4", children: [_jsxs(Stack, { direction: "row", gap: "2", children: [_jsx(LiveIcon, { className: "mt-0.5 size-4 shrink-0 text-green-500" }), _jsxs(Stack, { gap: "1", children: [_jsx(BtwText, { className: "font-medium", variant: "white", children: "A new live session is waiting" }), _jsx(LiveSessionText, { displayName: displayName, isUserInCurrentLiveProject: isUserInCurrentLiveProject, userTestName: userTestName })] })] }), _jsx(BtwLink, { href: `/share/live/session/${userTestUuid.split('_')[1]}/${roomId}`, className: "self-center !no-underline", target: "_blank", children: _jsx(BtwButton, { variant: "secondary", size: "sm", children: "Join" }) })] })),
        options: { closeOnClick: true, autoClose: false },
    });
};
const LiveSessionText = ({ displayName, isUserInCurrentLiveProject, userTestName, }) => (_jsxs(BtwText, { leading: "snug", weight: "normal", size: "13", variant: "white", children: [displayName, " just joined a live session on", ' ', isUserInCurrentLiveProject ? ('this') : (_jsx("span", { className: "font-semibold", children: userTestName })), ' ', "project"] }));
